// JAPAN WEB CLINIC (Dawn) — the receiving form (product page ?step=receive; the cart's 「変更」 later).
// - Shows the parts that apply (travelling / living in Japan, delivery / pickup, abroad, cold medicine), the arrival
//   check by the chosen delivery date (F-07), the carry check, the certificate's fields, the total.
// - The country comes right after the stay (owner 2026-10-21, plan purchase-ux §8): over its quantity guide, a red box
//   says so at once, offers the most the guide allows (same dose, one tap) and how 2 people order (one order each, so
//   each gets a certificate). Advice only: the order is never stopped. 「日本に住んでいる」 starts with 「日本国内でのみ使用」.
// - Keeps a draft while typing (sessionStorage), and fills the form from the cart's saved attributes (acceptance R07).
// - Confirm (R09): checks everything first (okurun §4-1・§5), then exactly once: add the medicine (and the certificate /
//   cooler bag) → save the attributes → read the cart back and compare. After a failure the cart is read again, so a
//   retry never adds the medicine twice. Then Dawn's cart notification opens (its button leads to the cart page).
(() => {
  'use strict';
  const J = window.JWC;
  const root = document.querySelector('[data-jwc-receive]');
  const dataEl = document.querySelector('[data-jwc-receive-data]');
  if (!J || !root || !dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  // 'step' (product page: adds the chosen medicine) or 'cart' (the cart's 「変更」: saves the receiving details and the
  // certificate / cooler bag only, then reloads the cart page)
  const MODE = root.dataset.jwcReceive || 'step';
  const T = J.texts(D.T);
  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));
  const form = $('[data-jwc-receive-form]');
  const DRAFT_KEY = 'jwc-receive-draft';
  const routes = window.routes || {};
  const cartUrl = (routes.cart_url || '/cart').replace(/\/$/, '');
  const settings = J.settings || {};
  const schedule = () => J.makeSchedule(settings.schedule || {});
  const money = (cents) => J.money(cents, D.moneyFormat);
  const rules = D.carryRules?.countries || {};
  const certId = D.certificate?.variantId;
  const coolerIds = (D.cooler || []).map((c) => c.variantId);
  const queue = J.serialQueue();
  let cart = null;
  let busy = false;
  let collapsed = false;
  // the cooler bag chosen in the draft or the cart: its boxes are built by the first render, after the form is filled,
  // so the choice waits here until then (JWC-05: the bag was dropped from the cart when the receipt was saved)
  let coolerWant = '';
  const coolerBuilt = () => Boolean($('[data-cooler-options]')?.dataset.built);

  // ---------------------------------------------------------------- form ⇄ state
  const FIELDS = ['pref', 'hotel', 'phone', 'reservation', 'checkin', 'checkout', 'date', 'time', 'returnDate', 'pickupDate', 'pickupTime', 'passportSurname', 'passportGiven', 'destination'];
  const CERT_FIELDS = { certNative: 'native', certDob: 'dob', certSex: 'sex', certNationality: 'nationality', certNumber: 'number', certAddress: 'address' };
  const field = (name) => form.elements.namedItem(name);
  function readState() {
    const s = { stay: form.elements.stay?.value || 'traveling', method: form.elements.method?.value || 'delivery' };
    FIELDS.forEach((k) => (s[k] = field(k)?.value || ''));
    // F-66: the order's one passport_name is 「SURNAME GIVEN NAMES」 (given names may be empty: one-name passports)
    s.passport = [s.passportSurname, s.passportGiven].map((x) => String(x || '').trim()).filter(Boolean).join(' ');
    const c = {};
    Object.entries(CERT_FIELDS).forEach(([name, key]) => (c[key] = field(name)?.value || ''));
    const cooler = coolerBuilt() ? $$('[data-cooler]:checked').map((i) => i.dataset.cooler)[0] || '' : coolerWant;
    return { receipt: s, cert: c, certificate: Boolean(field('certificate')?.checked), cooler };
  }
  // the date of birth's three selects ⇄ the hidden certDob (YYYY-MM-DD; '' until all three are chosen)
  const dobParts = () => ['certDobY', 'certDobM', 'certDobD'].map((n) => field(n));
  function dobFromParts() {
    const [y, m, d] = dobParts();
    if (field('certDob') && y) field('certDob').value = y.value && m.value && d.value ? `${y.value}-${m.value}-${d.value}` : '';
  }
  function dobToParts() {
    const [y, m, d] = dobParts();
    if (!field('certDob') || !y) return;
    const v = /^\d{4}-\d{2}-\d{2}$/.test(field('certDob').value) ? field('certDob').value.split('-') : ['', '', ''];
    [y, m, d].forEach((el, i) => (el.value = v[i]));
  }
  const dobSync = (e) => /^certDob[YMD]$/.test(e.target?.name || '') && dobFromParts();
  form.addEventListener('input', dobSync, true);
  form.addEventListener('change', dobSync, true);

  function writeState(st) {
    if (!st) return;
    let s = st.receipt || {};
    // a saved passport_name only (carts saved before the two fields were kept): never split at a space (JWC-08:
    // 「VAN DER BERG」「JAN」 came back as 「VAN」「DER BERG JAN」). This browser's prefill for the same name has the two
    // fields; otherwise one word is the surname, and more are left for the guest to type again.
    if (s.passport && s.passportSurname === undefined) {
      const passport = J.passportName(s.passport);
      const p = prefillFor(passport);
      const words = passport.split(' ');
      s = { ...s, passportSurname: p ? p.lastName : words.length === 1 ? words[0] : '', passportGiven: p ? p.firstName || '' : '' };
    }
    if (s.stay) $$('input[name="stay"]').forEach((i) => (i.checked = i.value === s.stay));
    if (s.method && D.pickupEnabled) $$('input[name="method"]').forEach((i) => (i.checked = i.value === s.method));
    FIELDS.forEach((k) => {
      const el = field(k);
      if (el && s[k] !== undefined && s[k] !== null) el.value = s[k];
    });
    Object.entries(CERT_FIELDS).forEach(([name, key]) => {
      const el = field(name);
      if (el && st.cert && st.cert[key] !== undefined) el.value = st.cert[key];
    });
    dobToParts();
    if (field('certificate') && st.certificate !== undefined) field('certificate').checked = Boolean(st.certificate);
    if (st.cooler !== undefined) {
      coolerWant = st.cooler || '';
      // a draft from the time of two sizes (S・M) chose a bag: with one bag left, that bag (2026-10-26)
      if (coolerWant && D.cooler?.length === 1) coolerWant = D.cooler[0].key;
      $$('[data-cooler]').forEach((i) => (i.checked = i.dataset.cooler === coolerWant));
    }
  }
  function prefillFor(passport) {
    try {
      const p = JSON.parse(localStorage.getItem('jwc-checkout-prefill') || 'null');
      return p && p.passport === passport && p.lastName ? p : null;
    } catch (e) {
      return null;
    }
  }
  function saveDraft() {
    try {
      sessionStorage.setItem(DRAFT_KEY, JSON.stringify(readState()));
    } catch (e) {
      /* the form keeps the values on screen */
    }
  }
  const readDraft = () => {
    try {
      return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null');
    } catch (e) {
      return null;
    }
  };
  // the certificate's page (plan certificate §4): its links show when Theme settings → 「診断書のページへのリンクを出す」 is
  // on, or in a tab that opened the page while it is off (jwc-cert-preview, set by assets/jwc-cert.js). From step 2 the
  // links keep the way back (jwc-cert-return); the page's 「診断書を追加する」 asks for the certificate on return (jwc-cert-jump).
  const session = (k, v) => {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k);
      else sessionStorage.setItem(k, v);
    } catch (e) {
      /* private mode: no way back, the links still open the page */
    }
    return null;
  };
  const certGate = Boolean(D.certPage?.live) || session('jwc-cert-preview') === '1';
  const certDest = (d) => (['tw', 'cn', 'kr'].includes(d) ? d : 'other');

  // ---------------------------------------------------------------- the pick and the cart
  const pick = () => J.readPick?.() || null;
  const pickVariant = () => {
    if (MODE !== 'step') return null;
    const p = pick();
    return p && D.product && D.product.variants[p.variantId] && Number(p.productId) === Number(D.product.id) ? { id: Number(p.variantId), ...D.product.variants[p.variantId] } : null;
  };
  const known = () => {
    const m = new Map();
    if (D.product) Object.entries(D.product.variants).forEach(([id, v]) => m.set(Number(id), { group: D.product.carryGroup || null, pens: v.pens || null }));
    Object.entries(D.cartVariants || {}).forEach(([id, v]) => m.set(Number(id), { group: v.group || null, pens: v.pens || null }));
    if (certId) m.set(certId, { group: null, pens: 0 });
    coolerIds.forEach((id) => m.set(id, { group: null, pens: 0 }));
    return m;
  };
  function pensTotal() {
    const group = D.product?.carryGroup || Object.values(D.cartVariants || {}).find((v) => v.group)?.group || null;
    const { total, unknown } = J.cartPens(cart?.items || [], known(), group);
    const v = pickVariant();
    const already = v && (cart?.items || []).some((l) => l.variant_id === v.id);
    return { total: total + (v && !already ? v.pens || 0 : 0), unknown };
  }
  const isCertLine = (l) => l.variant_id === certId;
  const isCoolerLine = (l) => coolerIds.includes(l.variant_id);

  // ---------------------------------------------------------------- what shows
  const abroad = (s) => Boolean(s.destination && s.destination !== 'jp');
  function render() {
    const st = readState();
    const s = st.receipt;
    root.dataset.stay = s.stay;
    root.dataset.method = s.method;
    $$('[data-when-stay]').forEach((el) => (el.hidden = el.dataset.whenStay !== s.stay));
    $$('[data-when-method]').forEach((el) => (el.hidden = el.dataset.whenMethod !== s.method));
    // the return date: one field, under the arrival check (delivery) or the clinic's pick-up day (pick-up)
    const ret = $('[data-field="returnDate"]');
    const slot = $(`[data-return-slot="${s.method}"]`);
    if (ret && slot && ret.parentElement !== slot) slot.append(ret);
    // the delivery date's calendar starts at the earliest day it can arrive for the prefecture (owner 2026-10-22)
    if (field('date')) field('date').min = s.pref ? schedule().earliestDelivery(s.pref) : schedule().today;
    $$('[data-when-abroad]').forEach((el) => (el.hidden = !abroad(s) || !D.certificate));
    if (!abroad(s) && field('certificate')) field('certificate').checked = false;
    $$('[data-when-certificate]').forEach((el) => (el.hidden = !(abroad(s) && field('certificate')?.checked)));
    const gates = $$('[data-cert-gate]');
    gates.forEach((el) => (el.hidden = !certGate));
    $$('[data-cert-lead]').forEach((el) => (el.hidden = certGate && gates.length > 0));
    $$('[data-cert-lang]').forEach((el) => (el.hidden = el.dataset.certLang !== certDest(s.destination)));
    const name = $('[data-cert-name]');
    if (name) name.textContent = J.passportName(s.passport) || '—';
    renderCooler();
    renderArrival(s);
    renderPickupTimes();
    renderCarry(s);
    renderTotal();
    $$('[data-receive-fields]').forEach((el) => (el.hidden = collapsed));
    $('[data-receive-saved]').hidden = !collapsed;
  }
  function renderItem() {
    const v = pickVariant();
    const item = $('[data-receive-item]');
    if (!item) return;
    item.hidden = !v;
    if (!v) return;
    $('[data-receive-item-image]').src = v.image || '';
    $('[data-receive-item-title]').textContent = D.product.title;
    $('[data-receive-item-variant]').textContent = v.title;
    $('[data-receive-item-price]').textContent = v.priceText;
  }
  function renderCooler() {
    const box = $('[data-cooler-options]');
    if (!box) return;
    const cold = (Boolean(D.product?.cold) || Object.values(D.cartVariants || {}).some((v) => v.cold)) && (D.cooler || []).length > 0;
    box.hidden = !cold;
    if (!cold) return;
    if (!box.dataset.built) {
      box.dataset.built = '1';
      box.innerHTML = D.cooler.map((c) => {
        const id = `JwcReceive-cooler${c.key}`;
        return `<label class="facet-checkbox jwc-check" for="${id}"><input type="checkbox" id="${id}" data-cooler="${c.key}">`
          + '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect width="16" height="16" fill="none" stroke="currentColor"></rect></svg>'
          + `<span class="svg-wrapper">${document.querySelector('.facet-checkbox .svg-wrapper')?.innerHTML || ''}</span>`
          + `<span class="facet-checkbox__text"><span class="jwc-option__line"><span class="jwc-option__name"></span>`
          + '<span class="caption jwc-option__fit" hidden></span><span class="caption jwc-option__upto"></span>'
          + `<span class="jwc-option__price">${c.priceText}</span></span></span></label>`;
      }).join('');
      D.cooler.forEach((c) => {
        const label = box.querySelector(`#JwcReceive-cooler${c.key}`).closest('label');
        label.querySelector('.jwc-option__name').textContent = J.fill(T.cooler, { size: c.size }).trim(); // one bag: no size name
        label.querySelector('.jwc-option__fit').textContent = T.cooler_fit;
        label.querySelector('.jwc-option__upto').textContent = c.upto ? J.fill(T.cooler_upto, { count: c.upto }) : '';
        // the size from the draft or the cart (writeState ran before these boxes were built)
        label.querySelector('[data-cooler]').checked = c.key === coolerWant;
      });
      // one size at a time
      box.addEventListener('change', (e) => {
        const input = e.target.closest('[data-cooler]');
        if (input?.checked) $$('[data-cooler]').forEach((i) => i !== input && (i.checked = false));
      });
    }
    // the size that fits the pens (the medicine now + what the cart has); with one bag there is nothing to choose between
    const pens = pensTotal().total;
    const sizes = D.cooler.filter((c) => c.upto > 0).sort((a, b) => a.upto - b.upto);
    const fit = D.cooler.length > 1 ? sizes.find((c) => pens <= c.upto) || sizes[sizes.length - 1] : null;
    $$('[data-cooler]').forEach((i) => (i.closest('label').querySelector('.jwc-option__fit').hidden = !fit || i.dataset.cooler !== fit.key));
  }
  function renderArrival(s) {
    const box = $('[data-arrival-result]');
    if (!box) return;
    const a = s.method === 'delivery' && s.stay === 'traveling' ? J.arrivalByDate(schedule(), s.pref, s.date, s.returnDate, T, { checkout: s.checkout }) : { state: 'empty' };
    box.hidden = a.state === 'empty';
    // a soft answer (the earliest day, Osaka for sooner) looks like information, without the ✕ (owner 2026-10-22)
    const look = a.soft ? 'info' : a.state;
    box.dataset.state = look;
    box.classList.toggle('is-tight', Boolean(a.tight));
    $$('[data-eta-icon]', box).forEach((el) => (el.hidden = el.dataset.etaIcon !== look));
    ['headline', 'when', 'deadline', 'before', 'osaka'].forEach((k) => {
      const el = $(`[data-a="${k}"]`, box);
      if (el) {
        el.textContent = a[k] || '';
        el.hidden = !a[k];
      }
    });
    const fix = $('[data-arrival-fix]', box);
    if (fix) {
      fix.hidden = !a.fix;
      fix.dataset.date = a.fix || '';
      fix.textContent = a.fix ? J.fill(T.arr_fix, { md: J.dateText(a.fix, T, 'date_md') }) : '';
    }
    const sw = $('[data-osaka-switch]', box);
    if (sw) sw.hidden = !a.osaka || !D.pickupEnabled;
  }
  // today: only the pick-up times after now + the lead time, before the same-day cutoff (F-56)
  function renderPickupTimes() {
    const select = field('pickupTime');
    if (!select || !select.options) return;
    const sch = schedule();
    const d = field('pickupDate')?.value || '';
    Array.from(select.options).forEach((o) => {
      if (o.value) o.disabled = d === sch.today && !sch.pickupSlotOk(d, o.value);
    });
  }
  function renderCarry(s) {
    const box = $('[data-carry-result]');
    if (!box) return;
    const p = pensTotal();
    const count = p.unknown ? undefined : J.carryCount({ destination: s.destination, carryMode: 'order' }, p.total);
    const reviewOnly = !(D.product?.carryGroup || Object.values(D.cartVariants || {}).some((v) => v.group));
    const a = J.carryAssessment({ destination: s.destination, carryMode: 'order' }, count, { rules, T, hub: D.hub, reviewOnly });
    const over = a.state === 'over';
    box.dataset.state = a.state;
    // over: the box says it (the general status and note give way; the country's own note stays)
    $('[data-carry-status]', box).textContent = a.status;
    $('[data-carry-status]', box).hidden = over;
    const overBox = $('[data-carry-over]', box);
    if (overBox) {
      overBox.hidden = !over;
      $('[data-carry-over-body]', overBox).textContent = over ? a.overBody : '';
      const fit = over ? fitVariant(a.maxPens) : null;
      const fix = $('[data-carry-fix]', overBox);
      fix.hidden = !fit;
      fix.dataset.variant = fit ? fit.id : '';
      fix.textContent = fit ? J.fill(T.carry_fix, { pack: fit.pack }) : '';
    }
    const flag = (D.flags || {})[s.destination] || '';
    $$('[data-carry-flag]').forEach((img) => {
      img.hidden = !flag;
      if (flag) img.src = flag;
    });
    $('.jwc-flag-select')?.classList.toggle('has-flag', Boolean(flag));
    const head = $('.jwc-carry-result__head', box);
    if (head) {
      $('[data-carry-country]', box).textContent = a.destination || '';
      head.hidden = !a.destination;
    }
    const limit = $('[data-carry-limit]', box);
    if (limit) {
      limit.textContent = a.limit || '';
      limit.hidden = !a.limit;
    }
    $('[data-carry-quantity]', box).textContent = s.destination && s.destination !== 'jp' && a.quantity !== '—' ? a.quantity : '';
    $('[data-carry-note]', box).textContent = (over ? a.ruleNote : a.note) || '';
    $('[data-carry-basis]', box).textContent = a.basis || '';
    const guide = $('[data-carry-guide]', box);
    if (guide) {
      guide.href = a.guide || D.hub;
      guide.hidden = !a.guide;
    }
  }
  // the most the guide allows for the pick: the same medicine with one option changed (the pack), available, the most
  // pens that still fit with what the cart holds. Only for a pick not in the cart yet (a cart line is changed there).
  function fitVariant(maxPens) {
    const v = pickVariant();
    if (!v || !v.options || !D.product?.carryGroup || (cart?.items || []).some((l) => l.variant_id === v.id)) return null;
    const room = maxPens - (pensTotal().total - (v.pens || 0));
    let best = null;
    Object.entries(D.product.variants).forEach(([id, c]) => {
      if (!c.available || !c.pens || c.pens >= v.pens || c.pens > room || !c.options) return;
      const diff = c.options.map((o, i) => (o === v.options[i] ? -1 : i)).filter((i) => i >= 0);
      if (diff.length === 1 && (!best || c.pens > best.pens)) best = { id: Number(id), pens: c.pens, pack: c.options[diff[0]] };
    });
    return best;
  }
  function totals() {
    const st = readState();
    const v = pickVariant();
    let sum = v ? v.price : 0;
    if (st.certificate && abroad(st.receipt) && D.certificate && !(cart?.items || []).some(isCertLine)) sum += D.certificate.price;
    const cooler = D.cooler.find((c) => c.key === st.cooler);
    if (cooler && !(cart?.items || []).some((l) => l.variant_id === cooler.variantId)) sum += cooler.price;
    return sum;
  }
  function renderTotal() {
    const total = totals();
    const text = money(total);
    document.querySelectorAll('[data-receive-total]').forEach((el) => (el.textContent = text));
    // F-79: the guide in the visitor's money under the total (snippets/jwc-fx.liquid)
    const fx = J.fxText(total, J.settings?.fx);
    document.querySelectorAll('[data-jwc-fx="receive"] [data-jwc-fx-approx]').forEach((el) => (el.textContent = fx));
    const certPrice = $('[data-certificate-price]');
    if (certPrice && D.certificate) certPrice.textContent = D.certificate.priceText;
  }

  // ---------------------------------------------------------------- checks
  const ctx = () => ({ schedule: schedule(), T, pickupEnabled: D.pickupEnabled, deliverySlots: D.deliverySlots, pickupSlots: D.pickupSlots });
  // the first issue in the order of the form (the return date comes before the passport name)
  const ORDER = ['stay', 'method', 'pref', 'hotel', 'phone', 'reservation', 'checkin', 'checkout', 'date', 'time', 'returnDate', 'pickupDate', 'pickupTime', 'passportSurname', 'passportGiven', 'passport'];
  // a pick-up asks the return date after the pick-up day and time
  const ORDER_PICKUP = ['stay', 'method', 'pickupDate', 'pickupTime', 'returnDate', 'passportSurname', 'passportGiven', 'passport'];
  function issueOf(st) {
    const s = st.receipt;
    const order = s.method === 'pickup' ? ORDER_PICKUP : ORDER;
    const r = [J.receiptIssue(s, ctx()), J.returnIssue(schedule(), s, T)].filter(Boolean).sort((a, b) => order.indexOf(a.field) - order.indexOf(b.field))[0];
    // the country comes right after the stay (the form's order)
    if (r && r.field === 'stay') return r;
    if (!Object.hasOwn(rules, s.destination)) return { field: 'destination', message: T.carry_err_destination };
    if (r) return r;
    if (st.certificate && abroad(s)) return J.certificateIssue(st.cert, schedule().today, T);
    return null;
  }
  let shown = null;
  function showIssue(issue, focus) {
    const box = $('.jwc-receive__error');
    $$('.jwc-field.has-error, [data-field].has-error').forEach((el) => el.classList.remove('has-error'));
    $$('[data-field-error]').forEach((p) => {
      root.querySelector(`[aria-describedby="${p.id}"]`)?.removeAttribute('aria-describedby');
      p.remove();
    });
    shown = issue || null;
    box.hidden = true;
    $('[data-receive-error]').textContent = '';
    if (!issue) return;
    if (collapsed && ORDER.includes(issue.field)) {
      collapsed = false;
      render();
    }
    const wrap = issue.field ? root.querySelector(`[data-field="${issue.field}"]`) : null;
    if (wrap && !wrap.hidden && !wrap.closest('[hidden]')) {
      wrap.classList.add('has-error');
      const msg = document.createElement('p');
      msg.className = 'jwc-field__error';
      msg.dataset.fieldError = '';
      msg.setAttribute('role', 'alert');
      msg.id = `JwcReceive-${issue.field}-error`;
      msg.textContent = issue.message;
      wrap.append(msg);
      const input = field(issue.field);
      (input instanceof RadioNodeList ? input[0] : input)?.setAttribute?.('aria-describedby', msg.id);
    } else {
      $('[data-receive-error]').textContent = issue.message;
      box.hidden = false;
    }
    if (focus) {
      const target = (issue.field === 'certDob' && field('certDobY')) || field(issue.field) || wrap;
      const el = target instanceof RadioNodeList ? target[0] : target;
      el?.focus?.({ preventScroll: true });
      (wrap || el)?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
    }
  }

  // ---------------------------------------------------------------- cart
  async function post(url, body) {
    for (let i = 0; i < 4; i++) {
      const res = await J.request(url, body);
      if (res.status !== 429) return res;
      await J.sleep(1200 * (i + 1));
    }
    return { ok: false, status: 429, data: null };
  }
  async function readCart() {
    cart = await J.fetchCart(cartUrl);
    return cart;
  }
  async function confirm() {
    const st = readState();
    const issue = issueOf(st);
    showIssue(issue, true);
    if (issue) return;
    const v = pickVariant();
    if (MODE === 'step' && (!v || !v.available)) {
      showIssue({ field: '', message: T.err_variant }, false);
      return;
    }
    setBusy(true);
    try {
      const now = await readCart();
      if (!now) throw Object.assign(new Error('cart'), { message_key: 'err_uncertain' });
      const items = [];
      // the medicine: once (a retry after a failure, or the same variant already in the cart, adds nothing)
      if (v && !now.items.some((l) => l.variant_id === v.id)) items.push({ id: v.id, quantity: 1 });
      // the certificate: one per order, quantity 1 (okurun §5); its properties follow the form
      const certLines = now.items.filter(isCertLine);
      const wantCert = st.certificate && abroad(st.receipt) && D.certificate;
      const props = wantCert ? J.certificateProperties(st.cert, st.receipt.passport) : null;
      // Sex is left out when not chosen: compare it too, so a line saved with it is replaced when it is cleared
      const sameProps = (l) => props && [...new Set([...Object.keys(props), 'Sex'])].every((k) => (l.properties?.[k] ?? '') === (props[k] ?? ''));
      const changes = [];
      certLines.forEach((l, i) => {
        if (!wantCert || i > 0 || !sameProps(l) || l.quantity !== 1) changes.push({ id: l.key, quantity: 0 });
      });
      if (wantCert && !(certLines[0] && sameProps(certLines[0]) && certLines[0].quantity === 1)) items.push({ id: certId, quantity: 1, properties: props });
      // the cooler bag: the chosen size only
      const cooler = D.cooler.find((c) => c.key === st.cooler);
      now.items.filter(isCoolerLine).forEach((l) => {
        if (!cooler || l.variant_id !== cooler.variantId) changes.push({ id: l.key, quantity: 0 });
      });
      if (cooler && !now.items.some((l) => l.variant_id === cooler.variantId)) items.push({ id: cooler.variantId, quantity: 1 });

      for (const c of changes) {
        const res = await post(`${routes.cart_change_url || '/cart/change'}.js`, c);
        if (!res.ok) throw Object.assign(new Error('change'), { message_key: 'err_add' });
        await J.sleep(300);
      }
      if (items.length) {
        const res = await post(`${routes.cart_add_url || '/cart/add'}.js`, { items });
        if (!res.ok) {
          const msg = res.data?.description || res.data?.message;
          throw Object.assign(new Error('add'), { message: msg ? J.fill(T.err_add_rejected, { message: msg }) : T.err_add });
        }
        await J.sleep(300);
      }
      await readCart();
      const attrs = J.receiptAttributes(st.receipt, pensTotal().total, D.locale);
      const saved = await J.saveAttributes({ cart: cartUrl, cartUpdate: (routes.cart_update_url || '/cart/update').replace(/\.js$/, '') }, attrs);
      if (!saved) throw Object.assign(new Error('attributes'), { message_key: 'err_attributes' });
      cart = saved;
      // the cart must now hold the medicine once, at most one certificate (quantity 1), the attributes
      const medicine = v ? saved.items.find((l) => l.variant_id === v.id) : saved.items.find((l) => !isCertLine(l) && !isCoolerLine(l));
      const certs = saved.items.filter(isCertLine);
      if (!medicine || certs.length > 1 || certs.some((l) => l.quantity !== 1) || !J.attributesMatch(saved, attrs)) {
        throw Object.assign(new Error('verify'), { message_key: 'err_uncertain' });
      }
      try {
        sessionStorage.removeItem(DRAFT_KEY);
        // F-66: what checkout's address can start with (the cart's checkout button reads it; this browser only, used
        // only while the order's passport name / hotel are the same)
        localStorage.setItem('jwc-checkout-prefill', JSON.stringify({
          passport: attrs.passport_name, lastName: J.passportName(st.receipt.passportSurname), firstName: J.passportName(st.receipt.passportGiven),
          hotel: attrs.hotel_name, found: J.hotelFound?.(attrs.hotel_name) || null,
        }));
      } catch (e) {
        /* checkout simply starts empty */
      }
      if (MODE === 'cart') {
        location.reload();
        return;
      }
      await notify(medicine.key, st);
      document.dispatchEvent(new CustomEvent('jwc:receipt-saved', { detail: { cart: saved, attributes: attrs } }));
    } catch (e) {
      await readCart();
      showIssue({ field: '', message: e.message_key ? T[e.message_key] : e.message || T.err_add }, false);
      $('.jwc-receive__error')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } finally {
      setBusy(false);
      render();
    }
  }
  function setBusy(on) {
    busy = on;
    document.querySelectorAll('button[form="' + form.id + '"]').forEach((b) => {
      b.disabled = on;
      b.classList.toggle('loading', on);
      b.querySelector('.loading__spinner')?.classList.toggle('hidden', !on);
    });
  }
  // Dawn's cart notification, rendered from the cart as it is now (sections of the medicine's line)
  async function notify(key, st) {
    const el = document.querySelector('cart-notification');
    if (!el) return;
    const ids = 'cart-notification-product,cart-notification-button,cart-icon-bubble';
    let sections = null;
    try {
      const res = await fetch(`${D.root.replace(/\/$/, '')}/?sections=${ids}`, { credentials: 'same-origin' });
      sections = await res.json();
    } catch (e) {
      sections = null;
    }
    const line = document.querySelector('[data-jwc-notification-receipt]');
    if (line) {
      const values = J.receiptValues(st.receipt, { T, slotLabel: (c) => D.slotLabels[c || ''] || c, prefLabel: J.prefLabel(D.prefNames) });
      const extra = [];
      if (st.certificate && abroad(st.receipt) && D.certificate) extra.push(T.certificate);
      const chosenCooler = D.cooler.find((c) => c.key === st.cooler);
      if (chosenCooler) extra.push(J.fill(T.cooler, { size: chosenCooler.size }).trim());
      line.textContent = J.fill(T.notification, { summary: values.summary }) + (extra.length ? J.fill(T.notification_with, { items: extra.join('・') }) : '');
      line.hidden = false;
    }
    if (sections && typeof el.renderContents === 'function') el.renderContents({ key, sections });
  }

  // ---------------------------------------------------------------- start
  async function open() {
    renderItem();
    if (MODE === 'step' && !pickVariant()) {
      // nothing picked (a reload of ?step=receive in a new tab): back to the product
      J.showStep?.(null);
      return;
    }
    await readCart();
    const draft = readDraft();
    const saved = J.receiptFromAttributes(cart?.attributes);
    const certLine = (cart?.items || []).find(isCertLine);
    const cert = certLine?.properties ? { native: certLine.properties['Native name'] || '', dob: certLine.properties['Date of birth'] || '', nationality: certLine.properties.Nationality || '', number: certLine.properties['Passport number'] || '', address: certLine.properties['Home address'] || '', sex: certLine.properties.Sex || '' } : null;
    // the bag in the cart stays chosen unless the guest unticks it (JWC-05)
    const cartCooler = D.cooler.find((c) => (cart?.items || []).some((l) => l.variant_id === c.variantId))?.key || '';
    if (draft) writeState(draft);
    else if (saved) writeState({ receipt: saved, cert, certificate: Boolean(certLine), cooler: cartCooler });
    else {
      // from the top's arrival check (prefecture and return date)
      writeState({ cooler: cartCooler });
      try {
        const eta = JSON.parse(sessionStorage.getItem('jwc-eta') || 'null');
        if (eta) writeState({ receipt: { pref: eta.pref || '', returnDate: eta.ret || '' } });
      } catch (e) {
        /* nothing to fill */
      }
    }
    // a second medicine with a valid saved receipt: show the summary and 「変更」 (acceptance R11)
    collapsed = MODE === 'step' && Boolean(!draft && saved && !J.receiptIssue(saved, ctx()) && !J.returnIssue(schedule(), saved, T));
    if (collapsed) {
      const values = J.receiptValues(saved, { T, slotLabel: (c) => D.slotLabels[c || ''] || c, prefLabel: J.prefLabel(D.prefNames) });
      $('[data-receive-saved-summary]').textContent = values.summary;
    }
    // dates: not before today in Japan
    const today = schedule().today;
    ['checkin', 'date', 'pickupDate', 'returnDate'].forEach((k) => field(k) && (field(k).min = today));
    if (field('certDob')) field('certDob').max = today;
    // back from the certificate's page with 「診断書を追加する」: tick it and show its fields
    const jump = session('jwc-cert-jump') === '1';
    if (jump) session('jwc-cert-jump', null);
    if (jump && field('certificate') && D.certificate && abroad(readState().receipt)) {
      field('certificate').checked = true;
      saveDraft();
    }
    render();
    if (jump) setTimeout(() => $('[data-certificate-option]')?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 300);
  }

  form.addEventListener('input', () => {
    saveDraft();
    render();
    if (shown) {
      const now = issueOf(readState());
      if (!now || now.field !== shown.field) showIssue(null);
      else if (now.message !== shown.message) showIssue(now, false);
    }
  });
  // F-74: a check-in day goes into an empty delivery date (or the earliest day it can arrive, when that is later); the
  // guest can change it. Only when the date is empty and shown (delivery); the checks stay jwc-core.js's (R04・R13).
  function fillDate(target) {
    const checkin = field('checkin');
    const date = field('date');
    if (target !== checkin || !checkin?.value || !date || date.value || date.closest('[hidden]')) return;
    const earliest = schedule().earliestDelivery(field('pref')?.value || '');
    date.value = checkin.value < earliest ? earliest : checkin.value;
  }
  // 「日本に住んでいる」 starts with 「日本国内でのみ使用」 (the guest can change it); back to 「滞在中」 clears it again while
  // it is still the one put there
  let autoJp = false;
  function stayDefault(target) {
    const dest = field('destination');
    if (!dest) return;
    if (target === dest) autoJp = false;
    if (target?.name !== 'stay') return;
    if (target.value === 'resident' && !dest.value) {
      dest.value = 'jp';
      autoJp = true;
    } else if (target.value === 'traveling' && autoJp && dest.value === 'jp') {
      dest.value = '';
      autoJp = false;
    }
  }
  form.addEventListener('change', (e) => {
    stayDefault(e.target);
    fillDate(e.target);
    saveDraft();
    render();
  });
  // 「3か月分にする」: the pick becomes the fitting pack (the product page's picker follows when the step closes,
  // assets/jwc-product.js); nothing is added to the cart until the form is confirmed
  form.addEventListener('click', (e) => {
    const fix = e.target.closest('[data-carry-fix]');
    if (!fix || !fix.dataset.variant || !J.setPick) return;
    J.setPick(Number(fix.dataset.variant));
    renderItem();
    render();
    const box = $('[data-carry-result]');
    box?.setAttribute('tabindex', '-1');
    box?.focus({ preventScroll: true });
  });
  form.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cert-link]');
    if (!link) return;
    saveDraft();
    if (MODE === 'step') session('jwc-cert-return', JSON.stringify({ url: location.href, at: Date.now() }));
    // before the page is switched on (checking in this tab), open the certificate's template on the product
    if (!D.certPage?.live) {
      const u = new URL(link.href, location.href);
      u.searchParams.set('view', 'certificate');
      link.href = u.href;
    }
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!busy) queue(confirm);
  });
  $('[data-receive-change]')?.addEventListener('click', () => {
    collapsed = false;
    render();
    $('[data-receive-fields]')?.querySelector('input, select')?.focus();
  });
  // 「{earliest}にする」: the earliest delivery day into the date (the guest asked for an earlier one)
  form.addEventListener('click', (e) => {
    const fix = e.target.closest('[data-arrival-fix]');
    if (!fix || !fix.dataset.date || !field('date')) return;
    field('date').value = fix.dataset.date;
    field('date').dispatchEvent(new Event('input', { bubbles: true }));
    field('date').dispatchEvent(new Event('change', { bubbles: true }));
  });
  form.addEventListener('click', (e) => {
    if (!e.target.closest('[data-osaka-switch]')) return;
    const pickup = form.querySelector('input[name="method"][value="pickup"]');
    if (!pickup) return;
    pickup.checked = true;
    saveDraft();
    render();
    const group = $('[data-when-method="pickup"]');
    group?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    field('pickupDate')?.focus({ preventScroll: true });
  });
  $('[data-receive-back]')?.addEventListener('click', (e) => {
    if (!J.showStep) return;
    e.preventDefault();
    J.showStep(null);
  });

  if (MODE === 'cart') {
    J.openReceive = open;
    return;
  }
  const bar = document.querySelector('[data-jwc-step-bar]');
  if (bar && bar.parentElement !== document.body) document.body.appendChild(bar);
  function onStep(step) {
    if (bar) bar.toggleAttribute('data-off', step !== 'receive');
    J.updateBars?.();
    if (step === 'receive') open();
  }
  document.addEventListener('jwc:step', (e) => onStep(e.detail?.step));
  if (document.documentElement.classList.contains('jwc-step-mode')) onStep('receive');
})();
